import React, {PropTypes} from 'react';
import VirtualEntryPaymentLogReservation from './VirtualEntryPaymentLogReservation.jsx';
import Panel from 'shared/Panel.jsx';

const VirtualEntryPaymentLog = ({
  reservationsDue,
  reservationsPaid
}) => (
  <div>
    <Panel title="Payment Log">
      {reservationsDue.length
        ? <div>
            <h4>{'Reservations Due'}</h4>
            {reservationsDue.map((item, index) => (
              <div key={index}>
                <VirtualEntryPaymentLogReservation {...item} />
                {index < reservationsDue.length - 1 ? <hr /> : null}
              </div>
            ))}
          </div>
        : null
      }
      {reservationsDue.length && reservationsPaid.length ? <hr /> : null}
      {reservationsPaid.length
        ? <div>
            <h4>{'Reservations Paid'}</h4>
            {reservationsPaid.map((item, index) => (
              <div key={index}>
                <VirtualEntryPaymentLogReservation {...item} />
                {index < reservationsPaid.length - 1 ? <hr /> : null}
              </div>
            ))}
          </div>
        : null
      }
    </Panel>
  </div>
);

VirtualEntryPaymentLog.propTypes = {
  reservationsDue: PropTypes.arrayOf(PropTypes.object),
  reservationsPaid: PropTypes.arrayOf(PropTypes.object)
};

VirtualEntryPaymentLog.defaultProps = {
  reservationsDue: [],
  reservationsPaid: []
};

export default VirtualEntryPaymentLog;



// WEBPACK FOOTER //
// ./src/features/registration/manage/VirtualEntryPaymentLog.jsx